export enum OrderItemType {
    Tariff = 1,
    TariffBarcode = 2,
    TariffPersonification = 3,
    TariffBarcodePesonification = 4,
    TariffRewritable = 5,
    ArenaTicket = 6,
    TariffRewritablePesonification = 7
}